export const smsCampaignMessageBody = (value) =>
  String(value || "")
    .trim()
    .replace(/لغو ?(?:۱۱|11)$/, "")
    .trim();

export const withSmsCampaignOptOut = (value) =>
  `${smsCampaignMessageBody(value)}\nلغو۱۱`;

export const countSmsMessageCharacters = (value) => {
  const text = String(value || "").trim();
  return {
    count: text.length,
    isPersian: Array.from(text).some((character) => character.charCodeAt(0) > 127),
  };
};
